const copyPath = (path) => Array.isArray(path) ? [...path] : [];

export function resolveItemFolderPath({ item, mappedPath, currentPath }) {
  if (Array.isArray(mappedPath)) return copyPath(mappedPath);

  const storedFullPath = item?.[2];
  if (Array.isArray(storedFullPath)) return storedFullPath.slice(0, -1);

  return copyPath(currentPath);
}

export function buildAnnotationSheetLocation({ sheetId, mode, folderPath }) {
  const joinedPath = copyPath(folderPath).join("/");
  return {
    pathname: `/annotation/${encodeURIComponent(sheetId)}/${mode}`,
    search: joinedPath ? `?path=${encodeURIComponent(joinedPath)}` : "",
  };
}
